module.exports = __webpack_public_path__ + "img/1440446912.8fd708a7.jpg";